module.exports = [
  {
    name: 'JustWatch',
    url: 'https://www.themoviedb.org%%tmdbUrl%%/watch',
    useIds: ['tmdbUrl']
  },
  {
    name: 'IMDB',
    url: 'https://www.imdb.com/title/%%imdb%%/',
    useIds: ['imdb']
  },
  {
    name: 'Metacritic',
    url: 'https://www.metacritic.com%%metacritic%%',
    useIds: ['metacritic']
  },
  {
    name: 'Rotten Tomatoes',
    url: 'https://www.rottentomatoes.com%%rtUrl%%',
    useIds: ['rtUrl']
  },
  {
    name: 'TMDB',
    url: 'https://www.themoviedb.org%%tmdbUrl%%',
    useIds: ['tmdbUrl']
  },
  {
    name: 'YouTube',
    url: 'https://www.youtube.com/results?search_query=%%query%%+trailer',
    space: '+'
  },  
  {
    name: 'Wikipedia',
    url: 'https://en.wikipedia.org/w/index.php?search=%%query%%&title=Special%3ASearch&go=Go&ns0=1',
    space: '+'
  },
  {
    name: 'Google',
    url: 'http://www.google.com/search?q=%%query%%',
    space: '+'
  }
]
